import { useTranslation } from "react-i18next"
import { Skeleton } from "@/components/ui/skeleton.tsx"
import { BackToPrevPageLink } from "@/feature/fundraising-advisory/components/BackToPrevPageLink.tsx"
import { ScrollableRouteContainer } from "@/components/shared/Container.tsx"
import { PageBody, PageHeader } from "@/components/shared/page-sections.tsx"

export const ListSkeleton = () => (
  <div className={`flex flex-col gap-4`}>
    <Skeleton className="h-[275px]  rounded-xl" />
    <Skeleton className="h-[275px]  rounded-xl" />
    <Skeleton className="h-[275px]  rounded-xl" />
  </div>
)

export const ExportButtonSkeleton = () => (
  <Skeleton className="h-10 w-[105px] rounded-md" />
)

export const VcMatchesPageSkeleton = () => {
  const { t } = useTranslation(`fundraising`)
  return (
    <ScrollableRouteContainer className={`p-0`}>
      <PageHeader className={`flex flex-col gap-6`}>
        <BackToPrevPageLink to={`..`} className={`self-start`}>
          {t(`fundraising.navigation.back_to_index`)}
        </BackToPrevPageLink>
        <div className={`flex justify-between items-center`}>
          <div className={`flex flex-col px-2 gap-1`}>
            <Skeleton className="h-8 w-52 rounded-md" />
            <Skeleton className="h-6 w-52 rounded-md" />
          </div>
          <ExportButtonSkeleton />
        </div>
      </PageHeader>
      <PageBody>
        <ListSkeleton />
      </PageBody>
    </ScrollableRouteContainer>
  )
}
